export default __webpack_public_path__ + "static/media/why-beta.d75fb07b.png";